import { c as _c } from "react/compiler-runtime";
import { cn } from "cn";
import { useId } from "react";
import { Checkbox, type CheckboxProps } from "./Checkbox";
interface CheckboxFieldProps extends CheckboxProps {
  label: React.ReactNode;
  error?: boolean;
}
function CheckboxField(t0) {
  const $ = _c(20);
  let className;
  let error;
  let externalId;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      label,
      error,
      id: externalId,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = error;
    $[3] = externalId;
    $[4] = label;
    $[5] = props;
  } else {
    className = $[1];
    error = $[2];
    externalId = $[3];
    label = $[4];
    props = $[5];
  }
  const generatedId = useId();
  const id = externalId ?? generatedId;
  const t1 = error ? "true" : undefined;
  let t2;
  if ($[6] !== className) {
    t2 = cn("peer", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== id || $[9] !== props || $[10] !== t1 || $[11] !== t2) {
    t3 = <Checkbox id={id} aria-invalid={t1} className={t2} {...props} />;
    $[8] = id;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("label-md cursor-pointer select-none text-foreground", "peer-disabled:cursor-default peer-disabled:opacity-50");
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== id || $[15] !== label) {
    t5 = <label htmlFor={id} className={t4}>{label}</label>;
    $[14] = id;
    $[15] = label;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t3 || $[18] !== t5) {
    t6 = <div className="flex items-center gap-2">{t3}{t5}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
export { CheckboxField, type CheckboxFieldProps };